package fr.manyverse.app.domain.model

data class InventoryItemToCreate(
    val characterId: String,
    val name: String,
    val category: ItemCategory,
    val quantity: Int = 1,
    val imageUrl: String? = null
)
